"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignBucket = exports.initializeExperimentState = exports.UpdateFetchExperiment = void 0;
var getBucketsFromChildren_1 = __importDefault(require("./getBucketsFromChildren"));
var services_1 = require("../services");
var utilities_1 = require("../utilities");
var fetchExperiment = function (props) {
    return services_1.FetchExperimentWithIdentifier(props);
};
function UpdateFetchExperiment(func) {
    fetchExperiment = func;
}
exports.UpdateFetchExperiment = UpdateFetchExperiment;
var initializeExperimentState = function (defaultBucket, buckets, previousValues) { return (__assign(__assign({}, previousValues), { defaultBucket: defaultBucket || (previousValues === null || previousValues === void 0 ? void 0 : previousValues.defaultBucket) || 'control', buckets: __spreadArray([], Array.from(new Set(((previousValues === null || previousValues === void 0 ? void 0 : previousValues.buckets) || []).concat(__spreadArray(__spreadArray([], buckets), ['control']))))) })); };
exports.initializeExperimentState = initializeExperimentState;
var assignBucket = function (assignedBucket, state, hasErrored) {
    if (hasErrored === void 0) { hasErrored = false; }
    return (__assign(__assign({}, state), { assignedBucket: assignedBucket, isLoading: false, hasErrored: hasErrored }));
};
exports.assignBucket = assignBucket;
var RegisterExperiment = function (props, updateExperiment) { return __awaiter(void 0, void 0, void 0, function () {
    var name, children, experiments, defaultBucket, serverCookies, identifier, buckets, existingExperiment, preloadedBucket, identifierToUse, experimentOptions, assignedBucket, hasErrored;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                name = props.name, children = props.children, experiments = props.experiments, defaultBucket = props.defaultBucket, serverCookies = props.serverCookies, identifier = props.identifier;
                buckets = children ? getBucketsFromChildren_1.default(children) : [];
                existingExperiment = experiments[name];
                experiments[name] = exports.initializeExperimentState(defaultBucket, buckets, experiments[name]);
                updateExperiment(name, experiments);
                preloadedBucket = services_1.Cookies.get(name) || serverCookies[name];
                if (preloadedBucket) {
                    experiments[name] = exports.assignBucket(preloadedBucket, experiments[name]);
                    updateExperiment(name, experiments, false);
                    return [2 /*return*/];
                }
                if (!!existingExperiment) return [3 /*break*/, 2];
                identifierToUse = identifier || utilities_1.getIdentifierFromAuthToken();
                experimentOptions = __assign(__assign({}, props), { identifier: identifierToUse });
                return [4 /*yield*/, fetchExperiment(experimentOptions)];
            case 1:
                assignedBucket = (_a.sent()).assignedBucket;
                hasErrored = !assignedBucket;
                experiments[name] = exports.assignBucket(assignedBucket || defaultBucket, experiments[name], hasErrored);
                _a.label = 2;
            case 2:
                updateExperiment(name, experiments);
                return [2 /*return*/];
        }
    });
}); };
exports.default = RegisterExperiment;
